import { render, staticRenderFns } from "./NotifOwnerCancel.vue?vue&type=template&id=1f118ad6&scoped=true"
import script from "./NotifOwnerCancel.vue?vue&type=script&lang=js"
export * from "./NotifOwnerCancel.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&id=1f118ad6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f118ad6",
  null
  
)

export default component.exports